<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <div
        class="relative pt-16 pb-32 flex content-center items-center justify-center"
        style="min-height: 25vh;"
      >
        <div class="absolute top-0 w-full h-full bg-center bg-cover">
          <span id="blackOverlay" class="w-full h-full absolute opacity-75 bg-black"></span>
        </div>
        <div class="container relative mx-auto">
          <div class="items-center flex flex-wrap">
            <div class="w-full lg:w-10/12 px-4 pt-20 ml-auto mr-auto text-center">
              <div class="pr-8">
                <h1
                  class="text-white font-semibold text-5xl sm:text-xl md:text-3xl lg:text-5xl xl:text-4xl"
                >Impressum</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container relative mx-auto px-4 pt-20 pb-40" style="min-height: 10vh;">
        <div class="justify-center ">
          <h2 class="text-2xl">Kontaktadresse</h2>
          <h3 class="text-lg">
            Blegistrasse 11a
            <br />6340 Baar
            <br />Schweiz
            <br />Tel. +41 41 760 18 18
          </h3>
        </div>
        <div class="pt-20">
          <iframe
            width="100%"
            height="350"
            frameborder="0"
            scrolling="no"
            marginheight="0"
            marginwidth="0"
            src="https://maps.google.ch/maps?f=q&amp;source=s_q&amp;hl=de&amp;geocode=&amp;q=Blegistrasse+11a,+6340+Baar&amp;aq=&amp;sll=46.362093,9.036255&amp;sspn=4.382298,9.876709&amp;ie=UTF8&amp;hq=&amp;hnear=Feldstrasse+20,+6300+Zug&amp;t=m&amp;z=16&amp;output=embed"
          ></iframe>
        </div>
        <div class="pt-20">
          <h2 class="text-2xl">Handelsregistereintrag</h2>
          <h3 class="text-lg">Eingetragener Firmenname: xpera GmbH</h3>
          <h3 class="text-lg">Nummer: CHE-250.702.453</h3>
          <h3 class="text-lg">Handelsregisteramt: Zug</h3>
        </div>
      </div>
    </main>
    <footer-component></footer-component>
  </div>
</template>

<script>
import NavbarComponent from "../components/Navbar.vue";
import FooterComponent from "../components/Footer.vue";
export default {
  name: "inmpressum",
  components: {
    NavbarComponent,
    FooterComponent
  }
};
</script>

<style>
</style>